const authenticationExcludedUrls = [
    '/channels/login',
    '/channels/choose-account',
    '/channels/mobile-login',
    '/shoper/mobile-login',
    '/shoper/login',
    '/livechat/login',
    '/aws-marketplace/login',
    '/invitation',
    '/videos/upload',
    '/videos/player',
    '/qr-code/',
    '/newsletter/',
    '/stop/',
    '/unsubscribing'
];

export const isAuthenticationExcludedUrl = () => authenticationExcludedUrls.some(url => window.location.href.includes(url));
